import { render, staticRenderFns } from "./novartis.vue?vue&type=template&id=85e9c88a&"
import script from "./novartis.vue?vue&type=script&lang=js&"
export * from "./novartis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports